import axiosApiInstance from './request';
const apiVersion = 'v2';

const getJobsService = async (params: any) => {
  const response = { data: {}, statusCode: 500 };
  try {
    const headers = { 'Content-Type': 'application/json' };
    const res = await axiosApiInstance.get('/job-posts/', {
      headers,
      apiVersion,
      params: params
    } as any);
    if (res && res.status === 200) {
      response.data = res?.data;
      response.statusCode = res?.status;
    }
  } catch (error: any) {
    console.error(error);
    response.statusCode = error?.data?.status;
  }
  return response;
};

const getJobByIdService = async (jobId: string) => {
  return await axiosApiInstance.get(`/job-posts/${jobId}/`, {
    apiVersion,
    observe: true
  } as any);
};

const deleteJobByIdService = async (jobId: string) => {
  const response = { data: {}, statusCode: 500 };
  try {
    const headers = { 'Content-Type': 'application/json' };
    const res = await axiosApiInstance.delete(`/job-posts/${jobId}/`, {
      headers
    });
    if (res) {
      response.data = res?.data;
      response.statusCode = res?.status;
    }
  } catch (error: any) {
    console.error(error);
    response.statusCode = error?.data?.status;
  }
  return response;
};

const inviteCoderService = async (payload: any) => {
  return await axiosApiInstance.post(`/invited-jobs/`, payload, { observe: true } as any);
};

const patchInvitedCoderJobPostService = async (payload: any, Id: any) => {
  let response: any = {};
  try {
    const headers = { 'Content-Type': 'application/json' };
    response = await axiosApiInstance.patch(`/invited-jobs/${Id}/`, payload, {
      headers
    } as any);
  } catch (error: any) {
    response = error;
  }
  return response;
};
const getInvitedCodersByJobId = async (payload: any) => {
  let response: any = {};
  try {
    const headers = { 'Content-Type': 'application/json' };
    response = await axiosApiInstance.post(`/get-invited-coders/`, payload, {
      headers
    } as any);
  } catch (error: any) {
    response = error;
  }
  return response;
};

const getInvitedCoderJobPostService = async (params: any) => {
  let response = {};
  try {
    const headers = { 'Content-Type': 'application/json' };
    response = await axiosApiInstance.get(`/invited-jobs/`, { headers, params } as any);
  } catch (error: any) {
    response = error;
  }
  return response;
};

const getRecommendedCoderJobPostService = async (params: any) => {
  let response = {};
  try {
    const headers = { 'Content-Type': 'application/json' };
    response = await axiosApiInstance.get(`/recommended-jobs/`, { headers, params } as any);
  } catch (error: any) {
    response = error;
  }
  return response;
};

const getLatestJobsService = async (params: any) => {
  let response = {};
  try {
    const headers = { 'Content-Type': 'application/json' };
    response = await axiosApiInstance.get(`/latest-job/`, {
      headers,
      params
    } as any);
  } catch (error: any) {
    response = error;
  }
  return response;
};

const getClientInviteJobService = async () => {
  let response = {};
  try {
    const headers = { 'Content-Type': 'application/json' };
    response = await axiosApiInstance.get(`/client-invite-job/`, {
      headers
    } as any);
  } catch (error: any) {
    response = error;
  }
  return response;
};

export {
  getJobsService,
  getJobByIdService,
  deleteJobByIdService,
  getInvitedCoderJobPostService,
  getRecommendedCoderJobPostService,
  inviteCoderService,
  patchInvitedCoderJobPostService,
  getLatestJobsService,
  getClientInviteJobService,
  getInvitedCodersByJobId
};
